import React from "react";
import kindergymbee from "../imgs/kindergymbeeanim.gif";

export default function KindergymBeeAnim() {
  return (
    <img id="kindergymBeeAnimImg" src={kindergymbee} alt="kindergym bee"/>
  )
}
